/**
 * Placeholder-only for Calendar forms.
 */
App.Views.Forms.Calendar = {};
